import { HttpClient } from "@angular/common/http";
import { Injectable } from "@angular/core";
import { environment } from "@uw-env/environment";
import { Observable, map } from 'rxjs';
import { AdminSiteContentResponse, CreateAdminSiteContentRequest, UpdateAdminSiteContentRequest } from "../api/models";
import { AdminSiteContent } from "../models/admin-site-content.model";


@Injectable({
  providedIn: "root"
})
export class AdminSiteContentService {

  constructor(
    private readonly _client: HttpClient
  ) { }

  save(adminSiteContent: AdminSiteContentResponse, pageMasterName?: string): Observable<AdminSiteContent> {
    const url = `${environment.apiURL}/administration/adminSiteContent/${pageMasterName}`;
    return this._client.post<{ data: AdminSiteContent }>(url, adminSiteContent).pipe(
      map(response => response.data)
    )
  }

  get(): Observable<AdminSiteContentResponse[]> {
    const url = `${environment.apiURL}/administration/adminSiteContent/list`;
    return this._client.get<{ data: AdminSiteContentResponse[] }>(url).pipe(
      map(response => response.data)
    )
  }

  getById(adminSiteContentId: number): Observable<AdminSiteContent> {
    const url = `${environment.apiURL}/administration/adminSiteContent/${adminSiteContentId}`;
    return this._client.get<{ data: AdminSiteContent }>(url).pipe(
      map(response => response.data)
    )
  }

}